<template>
  <Layout
    @componentKey="gotRefresh" 
    @currentPage="currentPage"
    :hasPagination="true"
    :hasBreadcrumbs="true"
    :amount="amount.aantal"
    :amountToShow="amountToShow"
  >
    <div class="content">
      <div class="page-content" ref="tableContent">
        <MainTitle :title="this.$router.currentRoute.name" />
        <backupstable
          @selectedAmount="gotAmountToShow"
          :totalItems="amount.aantal"
          @selectedRow="gotStep"
          :steps="this.steps"
          @sorting="gotSorting"
          @refresh="gotRefresh"
        />
      </div>
    </div>
  </Layout>
</template>
<script>
// @ is an alias to /src
import Layout from "@/layouts/Dashboard";
import Loading from "@/components/base/Loading";
import backupstable from "@/components/TblBackups";
import MainTitle from "@/components/base/MainTitle";
import TableFilter from "@/components/base/TableFilter";

export default {
  name: "management-backups",
  props: {
    compKey: Number
  },
  computed: {
    maxRows: function () {
      let heightContent = this.$refs.tableContent.clientHeight;
      let heightSingleRow = 76

      return Math.ceil(heightContent / heightSingleRow) - 2
    },
    userDetails() {
      return this.$store.state.userDetails
    }
  },
  data() {
    return {
      isLoading: false,
      steps: [],
      amount: 0,
      selectedStep: null,
      pagina: 1,
      openModalHandler: false,
      sortingOn: "ref",
      isAscending: true,
      amountToShow: 8
    };
  },
  components: {
    Layout,
    Loading,
    TableFilter,
    backupstable,
    MainTitle,
  },
  mounted() {
    this.amountToShow = this.maxRows
    this.getData();
  },
  methods: {
    gotAmountToShow(val) {
      if(val == 9) {
        this.amountToShow = this.maxRows
      } else {
        this.amountToShow = parseInt(val)
      }
      this.pagina = Math.ceil(this.amount.aantal / parseInt(val))
      this.getData()
    },
    getData() {
      var that = this      
      let offset = this.pagina != 1 ? (this.pagina * this.amountToShow) - this.amountToShow : 0
      let asc = this.isAscending ? "A" : "D";
      this.$http
        .get(
          this.$endpoint +
            "management/backup"+
            "/" +
            40 +
            "/" +
            0
        )
        .then(response => {
          this.amount = response.data.pop();
          this.steps = response.data.reverse();
          this.selectedStep = null;

          switch(this.sortingOn) {
            case 'ref':
              if(this.isAscending) {
                that.steps.sort((a, b) => (a.stepID > b.stepID) ? 1 : -1)
              } else {
                that.steps.sort((a, b) => (a.stepID < b.stepID) ? 1 : -1)
              }
              break;
          }
        })
        .catch(error => {
          if (error.response.status === 401) {
            this.$store
            .dispatch("logout")
            .then(() => this.$router.push("/login"))
            .catch(err => console.log(err));
          } else {
            that.$swal(
              'Oops that went wrong?',
              `Please contact the admin with the following info: ${ error }`,
              'error'
            );
          }
      });
    },
    currentPage(page) {
      this.pagina = page; // someValue
    },
    gotSorting(sort) {
      this.isAscending = sort.asc;
      this.sortingOn = sort.on;
      this.getData();
    },
    gotStep(mat) {
      this.selectedStep = mat; // someValue
      this.selectedStep.customValues = this.selectedStep.customStep;
    },
    gotClick(val) {
      this.openModalHandler = !this.openModalHandler;
    },
    gotRefresh(val) {
      this.pagina = 1
      this.amount = 0
      this.getData()
    },
    gotRefreshPageData(val) {
      this.amount = 0
      this.getData()
    }
  },
  watch: {
    pagina: function(val) {
      this.getData();
    },
    amount: function (newVal, oldVal) {
      if(newVal.aantal != oldVal && newVal.aantal != oldVal.aantal && oldVal != 0) {
        this.getData()
      }
    },
    filter: function(val) {
      this.getData();
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/style/base.scss";
@import "@/style/pages/content.scss";
@import "@/style/components/sidebar.scss";
/* 
.sidebar {
  background-color: red;
} */
</style>;